export const CATEGORY_PT = {
  Furniture: "Mobiliário",
  Lighting: "Iluminação",
  Interiors: "Interiores",
  Objects: "Objetos",
  Architecture: "Arquitetura",
  Installation: "Instalação",
  Object: "Objeto",
  All: "Todos",
};

export const STRINGS = {
  en: {
    nav_projects: "Projects",
    nav_about: "About",
    nav_contacts: "Contacts",
    home_index: "— Index",
    home_selected: "Selected Works",
    filter_all: "All",
    projects_word: "Projects",
    scroll_explore: "Scroll to explore",
    card_view: "View",
    detail_index: "Index",
    detail_category: "Category",
    detail_photographs: "Photographs",
    prev: "Previous",
    next: "Next",
    about_eyebrow: "— About",
    about_t1: "A studio for",
    about_t2: "shaping stone.",
    studio_eyebrow: "— The Studio",
    discipline: "Discipline",
    material: "Material",
    based_in: "Based in",
    projects_label: "Projects",
    discipline_val: "Furniture · Lighting · Architecture",
    material_val: "Marble · Travertine · Limestone",
    selected_works_suffix: "selected works",
    contacts_eyebrow: "— Contacts",
    contacts_t1: "Let's shape",
    contacts_t2: "something.",
    contacts_intro: "For bespoke commissions and collaborations with architects and interior designers.",
    email: "Email",
    studio: "Studio",
    enquiries: "Enquiries",
    rights: "All rights reserved",
    not_found: "Not found",
    back_to_projects: "Back to projects",
  },
  pt: {
    nav_projects: "Projetos",
    nav_about: "Sobre",
    nav_contacts: "Contactos",
    home_index: "— Índice",
    home_selected: "Trabalhos Selecionados",
    filter_all: "Todos",
    projects_word: "Projetos",
    scroll_explore: "Deslize para explorar",
    card_view: "Ver",
    detail_index: "Índice",
    detail_category: "Categoria",
    detail_photographs: "Fotografias",
    prev: "Anterior",
    next: "Seguinte",
    about_eyebrow: "— Sobre",
    about_t1: "Um atelier para",
    about_t2: "moldar pedra.",
    studio_eyebrow: "— O Atelier",
    discipline: "Disciplina",
    material: "Material",
    based_in: "Sediado em",
    projects_label: "Projetos",
    discipline_val: "Mobiliário · Iluminação · Arquitetura",
    material_val: "Mármore · Travertino · Calcário",
    selected_works_suffix: "trabalhos selecionados",
    contacts_eyebrow: "— Contactos",
    contacts_t1: "Vamos moldar",
    contacts_t2: "algo.",
    contacts_intro: "Para encomendas à medida e colaborações com arquitetos e designers de interiores.",
    email: "Email",
    studio: "Atelier",
    enquiries: "Pedidos",
    rights: "Todos os direitos reservados",
    not_found: "Não encontrado",
    back_to_projects: "Voltar aos projetos",
  },
};
